module.exports = __webpack_public_path__ + "img/EMT-ASHN_GSE227469.4d78305b.png";